export const EventNameOfferPageLaunch = 'offer_page_launch';
export const EventNameDealExpired = 'deal_expired';
export const EventNameOfferButtonClick = 'offer_button_click';
export const EventNameProductButtonClick = 'product_button_click';
export const EventNameQuantityChange = 'quantity_change';
export const EventNameOfferProductPage = 'offer_product_page';

export const EventActionATC = 'atc';
export const EventActionBuynow = 'bn';
export const EventActionFloating = 'floating';
export const EventActionOffer = 'offer';
export const EventActionClose = 'close';
export const EventActionCartPage = 'cart_page';
export const EventActionProductPage = 'product_page';

export const EventActionCheckout = 'checkout';
export const EventActionGoToCart = 'go_to_cart';
export const EventActionSkip = 'skip';
export const EventActionMinimize = 'minimize';
export const EventActionAdd = 'add';
export const EventActionGoToPage = 'go_to_page';
export const EventActionIncrease = 'increase';
export const EventActionDecrease = 'decrease';
export const EventActionSelect = 'select';
export const EventActionOpen = 'open';
export const EventActionBack = 'back';

export const EventVariableDefault = 'default';
export const EventVariableVariant = 'variant';
export const EventVariableRepeat = 'repeat';

export function getEventConstants() {
  return {
    EventActionCartPage,
    EventActionProductPage,
    EventActionOpen,
    EventActionSelect,
    EventNameOfferPageLaunch,
    EventNameOfferProductPage,
    EventNameProductButtonClick,
    EventVariableDefault,
    EventVariableVariant,
    EventActionDecrease,
    EventNameQuantityChange,
  };
}
